export default __webpack_public_path__ + "static/media/add-image-camera.d9f09949.svg";